import { sectionAspectRatio } from "@/shared/utils/aspect-ratio";
import { sectionMaxHeight } from "@/shared/utils/section-max-height";
import { StoreTemplate } from "@/templates/TemplateLoader";
import { FormattedDataType } from "@/templates/types";
import React from "react";

interface RenderCollectionCardProps {
  collection: FormattedDataType["collections"][0];
  section: Partial<FormattedDataType>;
  isSliderSection?: boolean;
  isOneElement?: boolean;
}

const RenderCollectionCard: React.FC<RenderCollectionCardProps> = ({
  collection,
  section,
  isSliderSection,
  isOneElement,
}) => {
  const Template = StoreTemplate.get();
  return (
    <Template.SectionCardWrapper
      isSlider={isSliderSection}
      data-test="collection-card"
      background={section?.background}
      isCollection
      aspectRatio={sectionAspectRatio(collection.image, isOneElement)}
      maxHeight={sectionMaxHeight(collection.image, isOneElement)}
    >
      <Template.CollectionCard
        collection={collection}
        hideTitle={!section?.showItemName}
      />
    </Template.SectionCardWrapper>
  );
};

export default RenderCollectionCard;
